import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useModals = defineStore('modals', () => {
  const show = ref({});
  const modalParams = ref({});

  const resetModals = () => {
    show.value = {};
    modalParams.value = {};
  };

  const setModal = ({ field, value = false, params = {} }) => {
    show.value[field] = value;
    modalParams.value[field] = params;
  };

  return {
    show,
    modalParams,
    resetModals,
    setModal,
  };
});
